import React from 'react'

import AddDistributorForm from '../../modules/Distributor/components/AddDistributorForm'
export default function AddDistributorPage() {
  return (
    <AddDistributorForm/>  )
}
